export default __webpack_public_path__ + "static/media/moon.ca85128c.jpg";